import { DEFAULT_GETTERS } from '@/modules/sale/constants';

export default {
  ...DEFAULT_GETTERS,
  list: (state) => state.list,
  notTaggedItemsIds: (state) => state.notTaggedItemsIds
};
